<template>
  <div>
    <app-spinner v-if="!page_loaded"/>
    <template v-else>
      <h1 class="title">VAT Statement ({{ vat_data.legal_entity.name }}) {{ dateFormatMonth(vat_data.from_date) }}</h1>
      <app-cells>
        <h2 class="title">TRA Statement</h2>
        <app-button @click.native="onUpdateVat" size="small" ref="submit">Save</app-button>
      </app-cells>
      <app-grid style="max-width: 1000px">
        <template #item-1>
          <app-flex-grid alignItems="end" :rows="[
          [1],
          [1],
          ['150px', '150px', '150px'],
          [1],
          ['150px', '150px', '150px'],
          [1],
          ['150px', '150px'],
          [1],
          ['150px', '150px'],
          [1],
          ['150px'],
          [1],
          ['150px']
        ]">
            <template #col-1-1><h2 class="title">PURCHASES OF GOODS AND SERVICES</h2></template>
            <template #col-2-1><h3 class="title">Standard Rated Purchases - Local (NET)</h3></template>
            <template #col-3-1>
              <app-form-field label="TRA" label-for="standard_rated_purchases_local_net">
                <app-fin-number
                  v-model="vat_data.standard_rated_purchases_local_net"
                  id="standard_rated_purchases_local_net"
                />
              </app-form-field>
            </template>
            <template #col-3-2>
              <app-form-field label="Board">
                <app-fin-number
                  v-model="analytics_data.purchases.net"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-3-3>
              <app-form-field label="Missing">
                <app-fin-number
                  v-model="analytics_data.purchases_missing.net"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-4-1><h3 class="title">Standard Rated Purchases - Local (VAT)</h3></template>
            <template #col-5-1>
              <app-form-field label="TRA" label-for="standard_rated_purchases_local_vat">
                <app-fin-number
                  v-model="vat_data.standard_rated_purchases_local_vat"
                  id="standard_rated_purchases_local_vat"
                />
              </app-form-field>
            </template>
            <template #col-5-2>
              <app-form-field label="Board">
                <app-fin-number
                  v-model="analytics_data.purchases.vat"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-5-3>
              <app-form-field label="Missing">
                <app-fin-number
                  v-model="analytics_data.purchases_missing.vat"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-6-1><h3 class="title">Exempt Purchases - Local</h3></template>
            <template #col-7-1>
              <app-form-field label="TRA" label-for="exempt_purchases_local">
                <app-fin-number
                  v-model="vat_data.exempt_purchases_local"
                  id="exempt_purchases_local"
                />
              </app-form-field>
            </template>
            <template #col-7-2>
              <app-form-field label="Board">
                <app-fin-number
                  v-model="analytics_data.purchases.exempted"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-8-1><h3 class="title">Non-creditable purchases - Local</h3></template>
            <template #col-9-1>
              <app-form-field label="TRA" label-for="non_creditable_purchases_local">
                <app-fin-number
                  v-model="vat_data.non_creditable_purchases_local"
                  id="non_creditable_purchases_local"
                />
              </app-form-field>
            </template>
            <template #col-9-2>
              <app-form-field label="Board">
                <app-fin-number
                  v-model="analytics_data.purchases.non_creditable"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-10-1><h3 class="title">Standard Rated Purchases - Imports (NET)</h3></template>
            <template #col-11-1>
              <app-form-field label="TRA"
                              label-for="standard_rated_purchases_import_net">
                <app-fin-number
                  v-model="vat_data.standard_rated_purchases_import_net"
                  id="standard_rated_purchases_import_net"
                />
              </app-form-field>
            </template>
            <template #col-12-1><h3 class="title">Standard Rated Purchases - Imports (VAT)</h3></template>
            <template #col-13-1>
              <app-form-field label="TRA"
                              label-for="standard_rated_purchases_import_vat">
                <app-fin-number
                  v-model="vat_data.standard_rated_purchases_import_vat"
                  id="standard_rated_purchases_import_vat"
                />
              </app-form-field>
            </template>
          </app-flex-grid>
        </template>
        <template #item-2>
          <app-flex-grid alignItems="end" :rows="[
          [1],
          [1],
          ['150px', '150px'],
          [1],
          ['150px', '150px'],
          [1],
          ['150px', '150px']
        ]">
            <template #col-1-1><h2 class="title">SUPPLIES OF GOODS AND SERVICES</h2></template>
            <template #col-2-1><h3 class="title">Standard Rated Sales (NET)</h3></template>
            <template #col-3-1>
              <app-form-field label="TRA" label-for="srs_net">
                <app-fin-number
                  v-model="vat_data.standard_rated_sales_net"
                  id="srs_net"
                />
              </app-form-field>
            </template>
            <template #col-3-2>
              <app-form-field label="Board">
                <app-fin-number
                  v-model="analytics_data.sales.net"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-4-1><h3 class="title">Standard Rated Sales (VAT)</h3></template>
            <template #col-5-1>
              <app-form-field label="TRA" label-for="srs_vat">
                <app-fin-number
                  v-model="vat_data.standard_rated_sales_vat"
                  id="srs_vat"
                />
              </app-form-field>
            </template>
            <template #col-5-2>
              <app-form-field label="Board">
                <app-fin-number
                  v-model="analytics_data.sales.vat"
                  readonly
                />
              </app-form-field>
            </template>
            <template #col-6-1><h3 class="title">Standard Rated Sales (Exempted)</h3></template>
            <template #col-7-1>
              <app-form-field label="TRA" label-for="exempt_sales">
                <app-fin-number
                  v-model="vat_data.exempt_sales_local"
                  id="exempt_sales"
                />
              </app-form-field>
            </template>
            <template #col-7-2>
              <app-form-field label="Board">
                <app-fin-number
                  v-model="analytics_data.sales.exempted"
                  readonly
                />
              </app-form-field>
            </template>
          </app-flex-grid>
        </template>
      </app-grid>
      <app-flex-grid alignItems="end" :rows="[
        [1],
        ['150px', '150px', '150px']
      ]">
        <template #col-1-1><h2 class="title">COMPUTATION OF TAX</h2></template>
        <template #col-2-1>
          <app-form-field label="Output Tax" label-for="vat_output">
            <app-fin-number
              v-model="vat_data.vat_output"
              id="vat_output"
            />
          </app-form-field>
        </template>
        <template #col-2-2>
          <app-form-field label="Input Tax" label-for="vat_input">
            <app-fin-number
              v-model="vat_data.vat_input"
              id="vat_input"
            />
          </app-form-field>
        </template>
        <template #col-2-3>
          <app-form-field label="VAT Credit" label-for="vat_credit">
            <app-fin-number
              v-model="vat_data.vat_credit"
              id="vat_credit"
            />
          </app-form-field>
        </template>
      </app-flex-grid>
      <app-cells>
        <h2 class="title">Purchases Import</h2>
        <app-button @click.native="onShowImportModal" size="small" ref="submit">Upload File</app-button>
      </app-cells>
      <table-detail-imports
        @clickPagination="onClickPaginationImports"
        :table-items="table_imports_items"
        :table-preloader="table_imports_preloader"
        :pagination="pagination_imports"
        :format-date-time="formatDateTime"
        :get-user-avatar="getUserAvatar"
        :download-file="downloadFile"
      />
      <app-cells>
        <app-button ref="link_supp" @click.native="onLinkSuppliers">Link Suppliers & Create EFD Receipts</app-button>
      </app-cells>
      <template v-if="table_missing_supplier_items.length">
        <app-cells><h2 class="title">Missing Supplier</h2></app-cells>
        <table-detail-missing-supplier
          @clickPagination="onClickPaginationMissingSupplier"
          :table-items="table_missing_supplier_items"
          :table-preloader="table_missing_supplier_preloader"
          :pagination="pagination_missing_supplier"
          :format-date="formatDate"
          :amount-format="amountFormat"
        />
      </template>
      <template v-if="table_missing_efd_items.length">
        <app-cells><h2 class="title">Missing EFD</h2></app-cells>
        <table-detail-missing-efd
          @clickPagination="onClickPaginationMissingEFD"
          :table-items="table_missing_efd_items"
          :table-preloader="table_missing_efd_preloader"
          :pagination="pagination_missing_efd"
          :format-date="formatDate"
          :amount-format="amountFormat"
        />
      </template>
      <template v-if="table_not_match_items.length">
        <app-cells><h2 class="title">Amount Not Match</h2></app-cells>
        <table-detail-not-match
          @clickPagination="onClickPaginationNotMatch"
          :table-items="table_not_match_items"
          :table-preloader="table_not_match_preloader"
          :pagination="pagination_not_match"
          :format-date="formatDate"
          :amount-format="amountFormat"
        />
      </template>
      <template v-if="table_missing_purchases_items.length">
        <app-cells><h2 class="title">Missing Purchases</h2></app-cells>
        <table-detail-missing-purchases
          @clickPagination="onClickPaginationMissingPurchases"
          :table-items="table_missing_purchases_items"
          :table-preloader="table_missing_purchases_preloader"
          :pagination="pagination_missing_purchases"
          :format-date="formatDate"
          :amount-format="amountFormat"
        />
      </template>
      <app-cells><h2 class="title">List of purchases</h2></app-cells>
      <table-detail-efd-purchases
        @clickPagination="onClickPaginationEFDPurchases"
        :table-items="table_efd_purchases_items"
        :table-preloader="table_efd_purchases_preloader"
        :pagination="pagination_efd_purchases"
        :format-date="formatDate"
        :amount-format="amountFormat"
      />
    </template>
    <modal
      name="import_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('import_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Purchases Import</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="File" required>
              <app-uploader
                v-model="import_file"
                :extensions="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
                formDataFormats="CSV,XLSX"
                class="custom-uploader--flex"
              />
              <template #error>
                <div v-if="$v.import_file.$dirty && !$v.import_file.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells :indent="false" position="center">
              <app-button type="submit" ref="import">Import</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getFinanceSuppliersEFDReceipts,
  getFinanceVatStatements,
  getFinanceVatStatementsFileList,
  getFinanceVatStatementsRecordsList,
  patchFinanceVatStatements,
  postFinanceVatStatementsFile,
  postFinanceVatStatementsRefresh,
  getFinanceAnalyticsAnalyticsEFD
} from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import TableDetailImports from '@/views/finance/taxes/vat/tables/TableDetailImports'
import TableDetailMissingSupplier from '@/views/finance/taxes/vat/tables/TableDetailMissingSupplier'
import TableDetailMissingEfd from '@/views/finance/taxes/vat/tables/TableDetailMissingEfd.vue'
import TableDetailNotMatch from '@/views/finance/taxes/vat/tables/TableDetailNotMatch'
import TableDetailMissingPurchases from '@/views/finance/taxes/vat/tables/TableDetailMissingPurchases'
import TableDetailEfdPurchases from '@/views/finance/taxes/vat/tables/TableDetailEfdPurchases.vue'
import axios from 'axios'

export default {
  name: 'VATStatementDetail',
  components: {
    TableDetailImports,
    TableDetailMissingSupplier,
    TableDetailMissingEfd,
    TableDetailNotMatch,
    TableDetailMissingPurchases,
    TableDetailEfdPurchases
  },
  data() {
    return {
      page_loaded: false,
      vat_data: {},
      analytics_data: {},
      import_file: null,
      table_imports_items: [],
      pagination_imports: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_imports_preloader: false,
      import_poll_timer: null,
      table_missing_supplier_items: [],
      pagination_missing_supplier: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_missing_supplier_preloader: false,
      table_missing_efd_items: [],
      pagination_missing_efd: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_missing_efd_preloader: false,
      table_not_match_items: [],
      pagination_not_match: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_not_match_preloader: false,
      table_missing_purchases_items: [],
      pagination_missing_purchases: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_missing_purchases_preloader: false,
      table_efd_purchases_items: [],
      pagination_efd_purchases: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_efd_purchases_preloader: false,
    }
  },
  validations: {
    import_file: {required},
  },
  async created() {
    await Promise.all([
      this.fetchData(),
      this.fetchImports(),
      this.fetchMissingSupplier(),
      this.fetchMissingEFD(),
      this.fetchNotMatch(),
    ])
    await this.fetchMissingPurchases()
    await this.fetchEFDPurchases()
    await this.fetchAnalytics()
    this.page_loaded = true
  },
  beforeDestroy() {
    clearTimeout(this.import_poll_timer)
  },
  methods: {
    async fetchAnalytics() {
      const response = await getFinanceAnalyticsAnalyticsEFD({
        from_date: this.vat_data.from_date,
        to_date: this.vat_data.to_date,
        legal_entity: this.vat_data.legal_entity.code,
      })
      this.analytics_data = response.data
    },
    async fetchData() {
      const response = await getFinanceVatStatements(this.$route.params.id)
      this.vat_data = response.data
    },
    async fetchImports() {
      clearTimeout(this.import_poll_timer)
      const activeIds = this.table_imports_items
        .filter(item => ['pending', 'processing'].includes(item.import_status))
        .map(item => item.id)
      this.table_imports_preloader = true
      const response = await getFinanceVatStatementsFileList(this.$route.params.id, {
        page: this.pagination_imports.page,
        page_size: 20
      })
      this.table_imports_items = response.data.results
      this.pagination_imports.pages = response.data.pages
      this.pagination_imports.count = response.data.count
      this.table_imports_preloader = false
      if (this.table_imports_items.some(item => activeIds.includes(item.id) && item.import_status === 'completed')) {
        this.fetchRecordTables()
      }
      if (this.table_imports_items.some(item => ['pending', 'processing'].includes(item.import_status))) {
        this.import_poll_timer = setTimeout(() => this.fetchImports(), 3000)
      }
    },
    async fetchMissingSupplier() {
      this.table_missing_supplier_preloader = true
      const response = await getFinanceVatStatementsRecordsList({
        page: this.pagination_missing_supplier.page,
        page_size: 20,
        category: 'missing_supplier',
        vat_statement: this.$route.params.id,
      })
      this.table_missing_supplier_items = response.data.results
      this.pagination_missing_supplier.pages = response.data.pages
      this.pagination_missing_supplier.count = response.data.count
      this.table_missing_supplier_preloader = false
    },
    async fetchMissingEFD() {
      this.table_missing_efd_preloader = true
      const response = await getFinanceVatStatementsRecordsList({
        page: this.pagination_missing_efd.page,
        page_size: 20,
        category: 'missing_efd',
        vat_statement: this.$route.params.id,
      })
      this.table_missing_efd_items = response.data.results
      this.pagination_missing_efd.pages = response.data.pages
      this.pagination_missing_efd.count = response.data.count
      this.table_missing_efd_preloader = false
    },
    async fetchNotMatch() {
      this.table_not_match_preloader = true
      const response = await getFinanceVatStatementsRecordsList({
        page: this.pagination_not_match.page,
        page_size: 20,
        category: 'amount_not_match',
        vat_statement: this.$route.params.id,
      })
      this.table_not_match_items = response.data.results
      this.pagination_not_match.pages = response.data.pages
      this.pagination_not_match.count = response.data.count
      this.table_not_match_preloader = false
    },
    async fetchMissingPurchases() {
      this.table_missing_purchases_preloader = true
      const response = await getFinanceSuppliersEFDReceipts({
        page: this.pagination_missing_purchases.page,
        page_size: 20,
        statement_record: false,
        vat: true,
        legal_entity: this.vat_data.legal_entity.code,
        from_date: this.vat_data.from_date,
        to_date: this.vat_data.to_date,
      })
      this.table_missing_purchases_items = response.data.results
      this.pagination_missing_purchases.pages = response.data.pages
      this.pagination_missing_purchases.count = response.data.count
      this.table_missing_purchases_preloader = false
    },
    async fetchEFDPurchases() {
      this.table_efd_purchases_preloader = true
      const response = await getFinanceSuppliersEFDReceipts({
        page: this.pagination_efd_purchases.page,
        page_size: 20,
        vat: true,
        legal_entity: this.vat_data.legal_entity.code,
        from_date: this.vat_data.from_date,
        to_date: this.vat_data.to_date,
      })
      this.table_efd_purchases_items = response.data.results
      this.pagination_efd_purchases.pages = response.data.pages
      this.pagination_efd_purchases.count = response.data.count
      this.table_efd_purchases_preloader = false
    },
    fetchTables() {
      this.fetchImports()
      this.fetchRecordTables()
    },
    fetchRecordTables() {
      this.fetchMissingSupplier()
      this.fetchMissingEFD()
      this.fetchNotMatch()
      this.fetchMissingPurchases()
      this.fetchEFDPurchases()
    },
    onClickPaginationImports(page) {
      this.pagination_imports.page = page
      this.fetchImports()
    },
    onClickPaginationMissingSupplier(page) {
      this.pagination_missing_supplier.page = page
      this.fetchMissingSupplier()
    },
    onClickPaginationMissingEFD(page) {
      this.pagination_missing_efd.page = page
      this.fetchMissingEFD()
    },
    onClickPaginationNotMatch(page) {
      this.pagination_not_match.page = page
      this.fetchNotMatch()
    },
    onClickPaginationMissingPurchases(page) {
      this.pagination_missing_purchases.page = page
      this.fetchMissingPurchases()
    },
    onClickPaginationEFDPurchases(page) {
      this.pagination_efd_purchases.page = page
      this.fetchEFDPurchases()
    },
    onLinkSuppliers() {
      this.$refs.link_supp.preload = true
      postFinanceVatStatementsRefresh(this.$route.params.id)
        .then(() => {
          this.fetchTables()
          this.$refs.link_supp.preload = false
        })
    },
    onUpdateVat() {
      this.$refs.submit.preload = true
      const data = {
        exempt_purchases_local: this.vat_data.exempt_purchases_local,
        exempt_sales_local: this.vat_data.exempt_sales_local,
        non_creditable_purchases_local: this.vat_data.non_creditable_purchases_local,
        standard_rated_purchases_import_net: this.vat_data.standard_rated_purchases_import_net,
        standard_rated_purchases_import_vat: this.vat_data.standard_rated_purchases_import_vat,
        standard_rated_purchases_local_net: this.vat_data.standard_rated_purchases_local_net,
        standard_rated_purchases_local_vat: this.vat_data.standard_rated_purchases_local_vat,
        standard_rated_sales_net: this.vat_data.standard_rated_sales_net,
        standard_rated_sales_vat: this.vat_data.standard_rated_sales_vat,
        vat_credit: this.vat_data.vat_credit,
        vat_input: this.vat_data.vat_input,
        vat_output: this.vat_data.vat_output,
      }
      patchFinanceVatStatements(this.$route.params.id, data)
        .then(() => {
          this.fetchData()
          this.fetchAnalytics()
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
          this.$refs.submit.preload = false
        })
        .catch(() => {
          this.$refs.submit.preload = false
        })
    },
    onShowImportModal() {
      this.import_file = null
      this.$v.$reset()
      this.$modal.show('import_modal')
    },
    onCheckForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.$refs.import.preload = true
        postFinanceVatStatementsFile(this.$route.params.id, {file: this.import_file.id})
          .then(() => {
            this.pagination_imports.page = 1
            this.fetchImports()
            this.$notify({
              type: 'success',
              title: 'Import queued',
            })
            this.$modal.hide('import_modal')
            this.$refs.import.preload = false
          })
          .catch(() => {
            this.$refs.import.preload = false
          })
      }
    },
    dateFormatMonth(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    formatDateTime(date) {
      return date ? format(parseISO(date), 'dd MMMM yyyy HH:mm') : '-'
    },
    formatDate(date) {
      return date ? format(parseISO(date), 'dd MMMM yyyy') : '-'
    },
    amountFormat(amount) {
      return amount ? new Intl.NumberFormat('ru-RU').format(amount) : '-'
    },
    downloadFile(row) {
      axios.get(row.file.file, {responseType: 'blob'})
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = row.file.file_name.split('.').pop()
          const part_of_name = `${row.created_by.full_name} - ${this.dateTimeFormat(row.created_at)} - ${row.skipped}`

          link.href = url
          link.setAttribute('download', `${part_of_name}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
  },
}
</script>
